import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { LocationAuditService } from "./location-audit.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { LocationAuditDto } from "./dto/location-audit.dto";
import { LocationById } from "../locations/dto/locaion-get-by-id.dto";

@ApiTags('locationAudit')
@Controller('locationAudit')

export class LocationAuditController { 
    constructor(
        private service: LocationAuditService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,

    ){}

    @Post('/createLocationAudit')
    async createLocationAudit(@Body() req: LocationAuditDto): Promise<CommonResponse> {
        try {
            return await this.service.createLocationAudit(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/updateLocationAudit')
    async updateLocationAudit(@Body() req: LocationAuditDto): Promise<CommonResponse> {
        try {
            return await this.service.updateLocationAudit(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    
    @Post('/getLocationAuditDetails')
    async getLocationAuditDetails(): Promise<CommonResponse> {
        try {
            return await this.service.getLocationAuditDetails();
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getAssetsByLocation')
    async getAssetsByLocation(@Body() req: LocationById): Promise<CommonResponse> {
        try {
            return await this.service.getAssetsByLocation(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }


}